(function () {
    'use strict';
    var controllerId = 'segnalazioneMonitora';
    angular.module('intro-app').controller(controllerId, ['$scope', 'common', '_', 'bootstrap.dialog', '$uibModalInstance', 'vcRecaptchaService', 'datacontext', '$translate', segnalazioneMonitoraFn]);

    function segnalazioneMonitoraFn($scope, common, _, bDialog, $uibModalInstance, vcRecaptchaService, datacontext, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.segnalazione = {};
        $scope.segnalazione.Id = 0;

        $scope.item = {};
        $scope.item.codice = '';
        $scope.item.segnalazioneDtl = [];
        $scope.item.risposte = [];
        $scope.item.cerca = getSegnalazione;
        $scope.item.loading = false;

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function (isValid) {
            if (isValid) {
                addItem($scope.item.segnalazioneDtl).then(function (result) {
                    $uibModalInstance.close(result);
                });
            }
        };

        function getSegnalazione() {
            if ($scope.item.codice && $scope.item.codice != '' && $scope.item.codice != null) {
                return datacontext.segnalazione_getByCode($scope.item.codice).then(function (data) {
                    if (data && data.Id > 0) {
                        getListSegnalazioniDtl(data.Id);
                        getSegnalazioniRisposte(data.CodiceId);
                        return $scope.segnalazione = data;
                    }
                });
            }
        }

        function getListSegnalazioniDtl(segnalazioneId) {
            return datacontext.segnalazioneDtl_getAllByFilter(segnalazioneId).then(function (data) {
                $scope.item.segnalazioneDtl = data;
            });
        }

        function getSegnalazioniRisposte(codiceId) {
            return datacontext.segnalazioneRisposta_getAllByFilter(codiceId).then(function (data) {
                $scope.item.risposte = data;
            });
        }

        function addItem(item) {
            $scope.item.loading = true;

            return datacontext.segnalazioneDtl_addEditMultiplo(item).then(function (data) {
                $scope.item.loading = false;

                if (!data) {
                    return logError($translate.instant('ErroreInserimento'));
                }

                logSuccess($translate.instant('SegnalazioneAggiunta'));
                return data;
            });
        }

        $scope.newLine = function () {
            var obj = {};
            obj.Id = 0;
            obj.SegnalazioneId = $scope.segnalazione.Id;

            $scope.item.segnalazioneDtl.push(obj);
        };

        $scope.deleteLine = function (item) {            
            if ($scope.item.segnalazioneDtl.length == 1) {
                logError($translate.instant('IndicareRichiesta'));
                return;
            }

            var msg = $translate.instant('LaRichiesta');
            if(item.Testo)
                var msg = $translate.instant('LaRichiesta') + ' ' + item.Testo;

            bDialog.deleteDialog(msg).then(function () {
                if (item.Id == 0) {
                    var index = _.findIndex($scope.item.segnalazioneDtl, function (o) {
                        return o == item;
                    });

                    $scope.item.segnalazioneDtl.splice(index, 1);
                } else {
                    return datacontext.segnalazioneDtl_delete(item.Id).then(function (data) {
                        if (data != "204") return logError($translate.instant('ErroreRimozione'));

                        var index = _.findIndex($scope.item.segnalazioneDtl, function (o) {
                            return o == item;
                        });

                        $scope.item.segnalazioneDtl.splice(index, 1);
                        logSuccess($translate.instant('DatoEliminato'));
                    });
                }
            });
        };
    }
})();